/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CampaignNumberGraphData } from './CampaignNumberGraphData';
import {
    CampaignNumberGraphDataFromJSON,
    CampaignNumberGraphDataFromJSONTyped,
    CampaignNumberGraphDataToJSON,
    CampaignNumberGraphDataToJSONTyped,
} from './CampaignNumberGraphData';
import type { CampaignMoneyGraphData } from './CampaignMoneyGraphData';
import {
    CampaignMoneyGraphDataFromJSON,
    CampaignMoneyGraphDataFromJSONTyped,
    CampaignMoneyGraphDataToJSON,
    CampaignMoneyGraphDataToJSONTyped,
} from './CampaignMoneyGraphData';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';
import type { MarketingTrendsData } from './MarketingTrendsData';
import {
    MarketingTrendsDataFromJSON,
    MarketingTrendsDataFromJSONTyped,
    MarketingTrendsDataToJSON,
    MarketingTrendsDataToJSONTyped,
} from './MarketingTrendsData';

/**
 * 
 * @export
 * @interface MarketingTrendsCompositionData
 */
export interface MarketingTrendsCompositionData {
    /**
     * 
     * @type {CampaignNumberGraphData}
     * @memberof MarketingTrendsCompositionData
     */
    pno?: CampaignNumberGraphData;
    /**
     * 
     * @type {CampaignNumberGraphData}
     * @memberof MarketingTrendsCompositionData
     */
    orders?: CampaignNumberGraphData;
    /**
     * 
     * @type {CampaignNumberGraphData}
     * @memberof MarketingTrendsCompositionData
     */
    clicks?: CampaignNumberGraphData;
    /**
     * 
     * @type {CampaignMoneyGraphData}
     * @memberof MarketingTrendsCompositionData
     */
    cpc?: CampaignMoneyGraphData;
    /**
     * 
     * @type {MarketingTrendsData}
     * @memberof MarketingTrendsCompositionData
     */
    totals?: MarketingTrendsData;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof MarketingTrendsCompositionData
     */
    snapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the MarketingTrendsCompositionData interface.
 */
export function instanceOfMarketingTrendsCompositionData(value: object): value is MarketingTrendsCompositionData {
    return true;
}

export function MarketingTrendsCompositionDataFromJSON(json: any): MarketingTrendsCompositionData {
    return MarketingTrendsCompositionDataFromJSONTyped(json, false);
}

export function MarketingTrendsCompositionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingTrendsCompositionData {
    if (json == null) {
        return json;
    }
    return {
        
        'pno': json['pno'] == null ? undefined : CampaignNumberGraphDataFromJSON(json['pno']),
        'orders': json['orders'] == null ? undefined : CampaignNumberGraphDataFromJSON(json['orders']),
        'clicks': json['clicks'] == null ? undefined : CampaignNumberGraphDataFromJSON(json['clicks']),
        'cpc': json['cpc'] == null ? undefined : CampaignMoneyGraphDataFromJSON(json['cpc']),
        'totals': json['totals'] == null ? undefined : MarketingTrendsDataFromJSON(json['totals']),
        'snapshot': json['snapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
    };
}

export function MarketingTrendsCompositionDataToJSON(json: any): MarketingTrendsCompositionData {
    return MarketingTrendsCompositionDataToJSONTyped(json, false);
}

export function MarketingTrendsCompositionDataToJSONTyped(value?: MarketingTrendsCompositionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pno': CampaignNumberGraphDataToJSON(value['pno']),
        'orders': CampaignNumberGraphDataToJSON(value['orders']),
        'clicks': CampaignNumberGraphDataToJSON(value['clicks']),
        'cpc': CampaignMoneyGraphDataToJSON(value['cpc']),
        'totals': MarketingTrendsDataToJSON(value['totals']),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
    };
}

